module.exports = __webpack_public_path__ + "img/29415304_166583630713703_1032667922171953152_n.bbd3ad5c.jpg";